import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';

const StickyContactButtons = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);

    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      setIsVisible(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(currentLanguage === 'en' ?'Hello, I would like to inquire about your legal services.' :'Hujambo, ningependa kuuliza kuhusu huduma zenu za kisheria.');
    window.open(`https://wa.me/254721320787?text=${message}`, '_blank');
  };

  const handleCallClick = () => {
    window.open('tel:+254721320787', '_self');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col space-y-3">
      {/* WhatsApp Button */}
      <div className="relative group">
        <Button
          variant="success"
          size="lg"
          onClick={handleWhatsAppClick}
          iconName="MessageCircle"
          className="w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 animate-bounce"
        />
        
        {/* Tooltip */}
        <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-text-primary text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          {currentLanguage === 'en' ? 'WhatsApp Us' : 'WhatsApp Nasi'}
          <div className="absolute top-1/2 -translate-y-1/2 -right-1 w-2 h-2 bg-text-primary rotate-45"></div>
        </div>
      </div>

      {/* Call Button */}
      <div className="relative group">
        <Button
          variant="primary"
          size="lg"
          onClick={handleCallClick}
          iconName="Phone"
          className="w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
        />
        
        {/* Tooltip */}
        <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-text-primary text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          {currentLanguage === 'en' ? 'Call Now' : 'Piga Simu'}
          <div className="absolute top-1/2 -translate-y-1/2 -right-1 w-2 h-2 bg-text-primary rotate-45"></div>
        </div>
      </div>
    </div>
  );
};

export default StickyContactButtons;